export default __webpack_public_path__ + "494f5eb3b662195d30734d6d5e2b6943.mp3";